module.exports = __webpack_public_path__ + "static/media/call.e723eeee.svg";